<template>
    <div class="container" :class="seasonClass">
        <div class="screen" :style="pageStyle">
            <div class="content">
                <div class="season2-logo">
                    <img
                        class="season2-logo1"
                        @click="toFullOrExit"
                        src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/spbcn-cebsb.png"
                        alt=""
                    />
                    <img
                        class="season2-logo2"
                        @click="getRankList"
                        src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season3/season3.png"
                        alt=""
                    />
                </div>
                <div class="rank-title">
                    <!-- <div class="title">全球总决选</div> -->
                    <div class="title title2" @click="getRankList">
                        {{ levelInfo(roomLevel).cn }}-排行榜
                    </div>
                    <div class="title enTitle">
                        Competition Ranking {{ levelInfo(roomLevel).en }}
                    </div>
                </div>
                <div class="rank-bg">
                    <div class="rank-flex">
                        <div class="rank-half">
                            <div class="rank-item rank-item1">
                                <div class="rank-index">排名</div>
                                <div class="rank-name">姓名</div>
                                <div class="rank-score" v-if="isShowScore">
                                    得分
                                </div>
                                <div class="rank-score" v-if="isShowScore">
                                    晋级
                                </div>
                            </div>
                            <div
                                class="rank-item"
                                :class="'rank-item-' + index"
                                v-for="(item, index) of rank1"
                                :key="index"
                            >
                                <div class="rank-index">
                                    {{ item.rankNum }}
                                </div>
                                <div class="rank-name">{{ item.userName }}</div>
                                <div class="rank-score" v-if="isShowScore">
                                    {{ item.score }}
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: green"
                                    v-if="item.promotion == 1"
                                >
                                    晋级
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: red"
                                    v-else-if="item.promotion == 2"
                                >
                                    淘汰
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: orange"
                                    v-else
                                >
                                    --
                                </div>
                            </div>
                        </div>
                        <div class="rank-half" v-if="rank2.length">
                            <div class="rank-item rank-item1">
                                <div class="rank-index">排名</div>
                                <div class="rank-name">姓名</div>
                                <div class="rank-score" v-if="isShowScore">
                                    得分
                                </div>
                                <div class="rank-score" v-if="isShowScore">
                                    晋级
                                </div>
                            </div>
                            <div
                                class="rank-item"
                                v-for="(item, index) of rank2"
                                :key="index"
                            >
                                <div class="rank-index">{{ item.rankNum }}</div>
                                <div class="rank-name">{{ item.userName }}</div>
                                <div class="rank-score" v-if="isShowScore">
                                    {{ item.score }}
                                </div>
                               <div
                                    class="rank-score"
                                    style="color: green"
                                    v-if="item.promotion == 1"
                                >
                                    晋级
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: red"
                                    v-else-if="item.promotion == 2"
                                >
                                    淘汰
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: orange"
                                    v-else
                                >
                                    --
                                </div>
                            </div>
                        </div>
                        <div class="rank-half" v-if="rank3.length">
                            ·
                            <div class="rank-item rank-item1">
                                <div class="rank-index">排名</div>
                                <div class="rank-name">姓名</div>
                                <div class="rank-score" v-if="isShowScore">
                                    得分
                                </div>
                                <div class="rank-score" v-if="isShowScore">
                                    晋级
                                </div>
                            </div>
                            <div
                                class="rank-item"
                                v-for="(item, index) of rank3"
                                :key="index"
                            >
                                <div class="rank-index">{{ item.rankNum }}</div>
                                <div class="rank-name">{{ item.userName }}</div>
                                <div class="rank-score" v-if="isShowScore">
                                    {{ item.score }}
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: green"
                                    v-if="item.promotion == 1"
                                >
                                    晋级
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: red"
                                    v-else-if="item.promotion == 2"
                                >
                                    淘汰
                                </div>
                                <div
                                    class="rank-score"
                                    style="color: orange"
                                    v-else
                                >
                                    --
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <img class="qr" v-if="seasonClass === 'season2'" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/right.jpg" alt=""> -->
            <img
                src="../../../assets/img/fs.png"
                class="fullscreen"
                @click="toFullOrExit"
                alt=""
            />
            <img
                src="../../../assets/img/refresh.png"
                class="fullscreen refresh"
                @click="getRankList"
                alt=""
            />
            <img
                src="../../../assets/img/fs.png"
                class="fullscreen-top"
                @click="toFullOrExit"
                alt=""
            />
            <img
                src="../../../assets/img/refresh.png"
                class="fullscreen-top refresh"
                @click="getRankList"
                alt=""
            />
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      seasonClass: '',
      screenWidth: 0,
      screenHeight: 0,
      dict_group: this.$userInfo.dict_group(),
      pageStyle: {
        width: '100%'
      },
      query: {
        season: '',
        raceSchedule: '',
        examinationId: '',
        isShowScore: 1
      },
      roomLevel: 0,
      roomName: '',
      rank1: [],
      rank2: [],
      rank3: [],
      round: 1, // 有组别轮次
      isShowScore: false // 是否显示分数
    }
  },
  mounted () {
    this.getScreenSize()
    window.addEventListener('resize', this.getScreenSize)
  },
  beforeDestory () {
    window.removeEventListener('resize', this.getScreenSize)
  },
  created () {
    document.title = '汉英双拼大会'
    this.query = this.$route.query
    console.log('query', this.query)

    // 处理分数显示逻辑
    this.handleScoreDisplay()

    // if (this.query.season === '2022~2023') {
    //   this.seasonClass = 'season1'
    // } else if (this.query.season === '2023~2024') {
    //   this.seasonClass = 'season2'
    // }
    this.seasonClass = 'season2'

    // if (this.query.group === '1') {
    //   this.round = this.query.round === 'A' ? 1 : this.query.round === 'B' ? 2 : this.query.round === 'C' ? 4 : 1
    // } else {
    //   this.round = this.query.round === 'A' ? 1 : this.query.round === 'B' ? 6 : 1
    // }

    this.getRankList()
  },
  methods: {
    // 处理分数显示逻辑
    handleScoreDisplay () {
      // 支持多种参数格式
      const scoreParam = this.query.isShowScore || this.query.isShowScore === 0 ? this.query.isShowScore : 1
      this.isShowScore = scoreParam === 1 || scoreParam === '1' || scoreParam === true
      console.log('分数显示状态:', this.isShowScore)
    },
    // round
    // 1 有组别A轮分数倒序，---小组赛A轮
    // 2 有组别AB轮综合分数倒序，---小组赛B轮
    // 3 有组别抽签顺序倒序，
    // 4 有组别 C轮分数倒序 ---小组赛C轮
    // 6 无组别
    getRankList () {
      this.$http.get('common/examinationUser/nationalRanking', {
        params: { ...this.query, ...{ isGroup: this.query.group } },
        showLoading: false
      }).then(res => {
        if (res.code === 200) {
          this.roomLevel = res.data.roomLevel
          this.roomName = res.data.roomName

          // 将数据平均分为三列
          const totalUsers = res.data.users.length
          const itemsPerColumn = Math.ceil(totalUsers / 3)

          this.rank1 = res.data.users.slice(0, itemsPerColumn)
          this.rank2 = res.data.users.slice(itemsPerColumn, itemsPerColumn * 2)
          this.rank3 = res.data.users.slice(itemsPerColumn * 2)

          console.log(this.rank1, this.rank2, this.rank3)
        }
      })
    },
    getScreenSize () {
      // const w = window.innerWidth // 屏幕宽
      const h = window.innerHeight // 屏幕高
      // 1920/1080
      const calcWidth = 1920 * h / 1080
      // console.log(calcWidth, w)
      // if (calcWidth < w) {
      if (this.seasonClass === 'season1') {
        this.pageStyle.width = parseInt(calcWidth) + 'px'
      }
      // } else {
      //   this.pageStyle.width = '100%'
      // }
      // const scale = h / 1080
      // this.test.transform = `scale(${scale})`
      // this.test.width = '1920px'
      // this.test.height = '1080px'

      // console.log(this.test)
    },
    requestFullScreen () {
      const de = document.documentElement
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    exitFullscreen () {
      const de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    toFullOrExit () {
      this.isFull = !this.isFull
      if (this.isFull) {
        // this.fullImg = require('@/assets/img/efs.png')
        this.requestFullScreen()
      } else {
        // this.fullImg = require('@/assets/img/fs.png')
        this.exitFullscreen()
      }
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    levelInfo (level) {
      return level ? this.dict_group.find(item => item.dictCode === Number(level)) : {}
    }
  }

}
</script>
<style scoped lang="less">
.container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
.screen {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    color: #000;
    font-family: "regular";
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}
.logo1 {
    position: absolute;
    left: 60px;
    top: 50px;
    width: auto;
    height: 67px;
}
.logo2 {
    position: absolute;
    right: 120px;
    top: 50px;
    width: auto;
    height: 70px;
}
.content {
    width: 100vw;
    height: 100vh;
    margin: 0 auto;
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_titlebg.png);
    box-sizing: border-box;
    position: relative;
    .title {
        text-align: center;
        font-size: 52px;
        color: #bb9138;
        text-shadow: -2px -2px 0px #ffffff, 2px 1px 0px #ffffff;
    }
    .title2 {
        font-size: 42px;
        position: relative;
        z-index: 10000;
    }
    .enTitle {
        font-size: 22px;
        margin-bottom: 10px;
    }
    .mb {
        margin-bottom: 200px;
    }
    .content-title {
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_titlebg1.png);
        background-size: cover;
        background-position: top center;
        background-repeat: no-repeat;
        width: 500px;
        height: 450px;
        margin: 0 auto;
        padding-top: 30px;
        padding-right: 20px;
        box-sizing: border-box;
        position: relative;
        z-index: 10;
    }
}
.rank-bg {
    height: 90vh;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

.rank-tip {
    font-size: 16px;
    color: #fff;
    text-align: right;
    position: absolute;
    top: 210px;
    right: 260px;
}
.rank-desc {
    width: 70%;
    color: #bb9138;
    // text-shadow: -2px -1px 0px #ffffff, 2px 2px 0px #ffffff;
    text-align: center;
    margin: 28px auto 0;
    .cn {
        font-size: 32px;
    }
    .en {
        font-size: 28px;
    }
}
.rank-flex {
    width: 80vw;
    margin-top: 220px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    max-height: 60vh;
    overflow-y: auto;
    margin: 0px 10vw;
    // padding: 0 80px;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(187, 145, 56, 0.6);
        border-radius: 4px;

        &:hover {
            background: rgba(187, 145, 56, 0.8);
        }
    }
}
.rank-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px;
}
.rank-half {
    margin: 10px 40px 0;
    // flex: 1;
    widows: 33%;
    min-width: 0;
}
.rank-index {
    // width: 73px;
    // height: 115px;
    // text-align: center;
    // line-height: 106px;
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_icon.png);
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-position: center;
    font-size: 32px;
    font-family: regular;
    color: #fff;
    width: 58px;
    margin-right: 20px;
    text-align: center;
}
.rank-num {
    width: 120px;
    font-size: 42px;
    font-family: regular;
    color: #f7b52c;
}
.rank-name {
    width: 140px;
    // font-size: 28px;
    // font-family: regular;
    font-size: 24px;
    font-family: fzcsk;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // margin-right: 20px;
    color: #000;
    // text-shadow: -2px -2px 2px #ffffff, 2px 2px 0px #ffffff;
}
.rank-score {
    width: 70px;
    font-size: 28px;
    text-align: center;
    color: #b81c25;
}
.fullscreen {
    width: 24px;
    height: 24px;
    position: fixed;
    left: 10px;
    bottom: 10px;
    cursor: pointer;
}
.fullscreen-top {
    width: 24px;
    height: 24px;
    position: fixed;
    left: 10px;
    top: 10px;
    cursor: pointer;
}
.refresh {
    left: 50px;
}
.rank-item-final {
    margin: 30px 0;
    .rank-name {
        font-family: shufa;
        font-size: 86px;
        text-shadow: -2px -2px 0px #000, 2px 2px 0px #000;
    }
    .rank-img {
        width: 64px;
        height: auto;
    }
    .rank-num {
        font-size: 62px;
        margin-right: 20px;
    }
}
.rank-img2 {
    width: 30px;
    margin-right: 60px;
}
.season1 {
    background-color: #b81c25;
    .screen {
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rankbg.png);
    }
    .rank-bg {
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_rank_titlebg2.png);
    }
    .rank-item1 {
        display: none;
    }
}
.season2 {
    .rank-bg {
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/rankbg.png);
        height: 82vh;
    }
    .screen {
        display: flex;
        align-items: center;
        justify-content: center;
        // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
        background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/2025/season3_bg_pure.jpg);
    }
    .qr {
        height: 100%;
        width: auto;
    }
    .rank-tip {
        color: #000;
    }
    .rank-item {
        margin: 0;
    }
    .rank-index {
        color: #000;
    }
    // .rank-name{
    //   color: #000;
    //   font-size: 28px;
    // }
    .rank-flex {
        margin-top: 111px;
    }
    .rank-num {
        color: #b81c25;
    }
    .rank-item-final {
        margin: 20px;
        .rank-name {
            font-family: shufa;
            font-size: 68px;
            text-shadow: none;
        }
        .rank-num {
            font-size: 68px;
            margin: 0 40px;
        }
    }
    .rank-desc {
        color: #000;
        position: absolute;
        width: 86%;
        left: 0;
        right: 0;
        bottom: 20px;
        .cn {
            font-size: 26px;
        }
        .en {
            font-size: 18px;
        }
    }
    .season2-logo {
        position: absolute;
        left: 20px;
        right: 20px;
        top: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
            height: 60px;
            width: auto;
        }
        .season2-logo2{
            height: 40px;
            margin-right: 40px;
        }
    }
    .rank-title {
        font-family: regular;
        margin-top: 100px;
        .title {
            font-size: 28px;
            text-shadow: none;
            color: #764b26;
        }
        .title2 {
            font-size: 46px;
            margin-top: 20px;
            color: #000;
        }
        .enTitle {
            font-size: 22px;
            color: #000;
        }
    }
    .rank-item1 {
        margin-bottom: 10px;
        .rank-index,
        .rank-name,
        .rank-score {
            font-size: 26px;
            font-family: regular;
            color: #764b26;
        }
    }
}
</style>
